/**
 * @desc 根据sku列表获取sku包装信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmSkuPackageInfoResponseRpcDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getSkuPackageInfoBySkuNos`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
